import { forwardRef } from 'react';

import MuiFormLabel from '@mui/material/FormLabel';
const FormLabel = forwardRef((props, ref) => {
  return <MuiFormLabel ref={ref} {...props} />;
});
FormLabel.displayName = 'FormLabel';
export default FormLabel;
